
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TypeStyleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TypeStyle"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fontFamilyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fontWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"letterSpacing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"textSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"textTransform"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":134}};
    doc.loc.source = {"body":"fragment TypeStyleFragment on TypeStyle {\n   fontFamilyId\n   fontWeight\n   letterSpacing\n   lineHeight\n   textSize\n   textTransform\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
